import React, { useState, useEffect } from 'react';
import DatePicker from 'react-multi-date-picker';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';
import gregorian from 'react-date-object/calendars/gregorian';
import './DateInput.css';

function DateInput({ label, value, onChange }) {
    const inputId = `date-input-${label.replace(/\s+/g, '-')}`;
    const [selectedDate, setSelectedDate] = useState(null);
    const today = new DateObject({
        date: new Date(),
        calendar: gregorian,
    }).convert(persian);

    useEffect(() => {
        if (value) {
            const parts = value.split('-').map(Number);
            if (parts.length === 3) {
                const parsedDate = new Date(parts[0], parts[1] - 1, parts[2]);
                const persianDate = new DateObject({
                    date: parsedDate,
                    calendar: gregorian,
                }).convert(persian);
                setSelectedDate(persianDate);
            }
        } else {
            setSelectedDate(null);
        }
    }, [value]);

    const handleChange = (date) => {
        if (!date) {
            setSelectedDate(null);
            onChange('');
            return;
        }
        const g = new DateObject(date).convert(gregorian);

        const gregDate = `${g.year}-${String(g.month.number).padStart(2, '0')}-${String(
            g.day
        ).padStart(2, '0')}`;
        onChange(gregDate);
    };

    return (
        <div className="date-input">
            <label htmlFor={inputId} className="date-label">
                {label}
            </label>
            <DatePicker
                id={inputId}
                calendar={persian}
                locale={persianFa}
                format="YYYY/MM/DD"
                value={selectedDate}
                onChange={handleChange}
                maxDate={today}
                portal
                portalTarget={document.body}
                className="date-picker"
            />
        </div>
    );
}

export default DateInput;
